export default __webpack_public_path__ + "static/media/Party icon.f4ff0cd5.png";